import analytics from 'scripts/lib/analytics';

export default class ObserverShow {
  constructor(context) {
    this.context = context;
  }

  run({ customerId, conversationItemId }) {
    let currentAgent = this.context.stores.currentAgent.get();

    this.context.gateways.phoneControlsHttp.observerShow(customerId, conversationItemId, {
      participantId: currentAgent.id,
    });

    analytics.track('Hero Coaching - Observer Shown', {
      customerId,
      conversationItemId,
    });
  }
}
